import { render, staticRenderFns } from "./WithdrawHistory.vue?vue&type=template&id=66fb2ecc&"
import script from "./WithdrawHistory.vue?vue&type=script&lang=js&"
export * from "./WithdrawHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports